/**
 * Shared rule for searchable option lists in filters (web + Android parity).
 * When a dropdown / multi-select / picker has more options than this threshold,
 * show an in-panel search field; at or below the threshold, hide it.
 */

/** Show option search when `optionCount` is strictly greater than this value. */
export const FILTER_OPTION_SEARCH_MIN_COUNT = 10;

export function showsFilterOptionSearch(optionCount: number): boolean {
  return optionCount > FILTER_OPTION_SEARCH_MIN_COUNT;
}

/** Case-insensitive compare without Czech diacritics (`Říčany` ↔ `ricany`). */
export function foldFilterSearchText(value: string | null | undefined): string {
  return String(value ?? '')
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLocaleLowerCase('cs-CZ')
    .trim();
}
